import React from 'react'
import {
  DsImage,
  DsImageProps,
  DsStack,
  DsStackProps,
  DsTypography
} from '@am92/react-design-system'

interface ISectionInfoProps {
  icon?: DsImageProps['srcSet']
  title: string
  description: string
  StackProps?: DsStackProps
}

const SectionInfo: React.FC<ISectionInfoProps> = props => {
  const { icon, title, description, StackProps } = props

  return (
    <DsStack
      direction='column'
      alignItems='center'
      spacing='var(--ds-spacing-glacial)'
      {...StackProps}
      sx={{
        maxWidth: { xs: '100%', md: '60%', lg: '30%' },
        ...StackProps?.sx
      }}
    >
      {icon && (
        <DsImage
          srcSet={icon}
          aspectRatio={1 / 1}
          WrapperProps={{
            sx: {
              height: { xs: '80px', md: '104px' },
              width: { xs: '80px', md: '104px' },
              mb: 'var(--ds-spacing-glacial) !important'
            }
          }}
        />
      )}
      <DsTypography variant='headingBoldLarge' sx={{ textAlign: 'center' }}>
        {title}
      </DsTypography>
      <DsTypography variant='bodyRegularLarge' sx={{ textAlign: 'center' }}>
        {description}
      </DsTypography>
    </DsStack>
  )
}

export default SectionInfo
